import { FULFILLED } from '../action-helper'
import { FETCH_SERVER_CAPABILITY } from './actions'
import { ServerCapabilityState } from './ServerCapabilityState'

const initialState: ServerCapabilityState = {
    byCapability: {},
    loaded: false,
}

export const serverCapabilityReducer = (state: ServerCapabilityState = initialState, action: any): ServerCapabilityState => {
    switch (action.type) {
        case FULFILLED(FETCH_SERVER_CAPABILITY):
            return { ...state, byCapability: action.payload, loaded: true }
    }

    return state
}
